import Col from '../Col2.js';
import TextBase from "./FieldTypeBase/TextBase";
import { forwardRef } from 'react';

const TextBlock = forwardRef((props, ref) => {
  return (
    <Col
      key={props.objectkey}
      id={props.objectkey}
      className={`col-md-${props.field.width} field ${props.field.class || ""}`}
    >
      <TextBase ref={ref} {...props} />
    </Col>
  );
});

export default TextBlock;